import { connect } from 'react-redux'
import ComingEvent, { Props } from '.'
import { ApplicationState } from '../../../../../reducers'
import { currentAndFutureEventsSelector } from '../../../../../data/selectors'

/**
 * Filters events to include only those where:
 *   - showCountdownTimer is undefined (property missing)
 *   - showCountdownTimer is true
 *   - showCountdownTimer is null
 * Excludes events where showCountdownTimer is false.
 */
function filterEvents(events: Props['events']) {
  return events.filter(event => {
    const { showCountdownTimer } = event
    return showCountdownTimer === undefined || showCountdownTimer === true || showCountdownTimer === null
  })
}

const mapStateToProps = (state: ApplicationState): Props => {
  const events = currentAndFutureEventsSelector(state)
  return { events: filterEvents(events) }
}

export default connect(mapStateToProps)(ComingEvent)
